import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import SortOption from '../models/SortOption';
import SortOptionToPageStatisticMapping from '../models/SortOptionToPageStatisticMapping';

import PageStatistic from 'apps/analytics/components/PageStatistic';

import FopViewTypeSwitch from '../containers/FopViewTypeSwitch';
import RefineByButton from './RefineByButton';
import SortSelect from '../containers/SortSelect';
import FoodProfileMobileSidebarHandler from '../containers/sidebar/FoodProfileMobileSidebarHandler';

export default class DisplayOptions extends PureComponent {
  static propTypes = {
    betaFeatures: PropTypes.array,
    displaySort: PropTypes.bool,
    excludedSort: PropTypes.array,
    onRefineByClick: PropTypes.func,
    pageParameters: PropTypes.shape({
      sort: PropTypes.string,
    }),
  };

  render() {
    const { betaFeatures, pageParameters, displaySort = false,
      onRefineByClick, excludedSort = [] } = this.props;
    const { sort } = pageParameters;

    const reportedSort = SortOptionToPageStatisticMapping[sort || SortOption.DEFAULT];
    const shouldDisplayRefineButton = onRefineByClick !== undefined;

    return (
      <>
        <div className="display-options">
          {shouldDisplayRefineButton && (
            <RefineByButton
              pageParameters={pageParameters}
              sortDisplay={displaySort}
              onRefineByClick={onRefineByClick}
            />
          )}
          {displaySort && (
            <SortSelect
              sort={sort}
              betaFeatures={betaFeatures}
              excludedSort={excludedSort}
            />
          )}
          {displaySort && (
            <PageStatistic
              field="SORT_BY"
              value={reportedSort}
            />
          )}
          <FopViewTypeSwitch />
        </div>
        <FoodProfileMobileSidebarHandler />
      </>
    );
  }
}
